import { authPost } from './authMiddleware';

export const postPropertyList = (data) => {
    return authPost('/api/Property', data);
}